"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function generateColor(color) {
  return ["#0083FF", color];
}

var _default = generateColor;
exports.default = _default;